// 🔧 use_promotion_ai.js
// ✅ Purpose: React hook for AI content generation in the LGV Promotion Engine
// ✅ Features:
// - Calls the secure AI Cloud Function
// - Exposes generation state
// - Stores latest AI result
// - Stores latest AI error
// - Clears previous results
// - Keeps React pages free from AI implementation details
// - Fully block-commented for clarity and future devs

import { useState } from "react";

import {
  generatePromotionContent,
} from "../services/promotion_ai_service";

/**
 * ============================================================================
 * usePromotionAI
 * ============================================================================
 *
 * Standard hook for AI generation.
 *
 * Future:
 * This pattern should become the standard for
 * every AI-enabled LGV Engine.
 */
export const usePromotionAI = () => {

  const [generating, setGenerating] =
    useState(false);

  const [result, setResult] =
    useState(null);

  const [error, setError] =
    useState(null);

  /**
   * --------------------------------------------------------------------------
   * Generate Draft
   * --------------------------------------------------------------------------
   */

  const generateDraft = async (
    request
  ) => {

    setGenerating(true);

    setError(null);

    setResult(null);

    try {

      const aiResult =
        await generatePromotionContent(
          request
        );

      setResult(aiResult);

      return aiResult;

    } catch (err) {

      console.error(
        "[Promotion AI]",
        err
      );

      setError(err);

      throw err;

    } finally {

      setGenerating(false);

    }

  };

  /**
   * --------------------------------------------------------------------------
   * Clear Current AI Result
   * --------------------------------------------------------------------------
   */

  const clearResult = () => {

    setResult(null);

    setError(null);

  };

  return {

    generating,

    result,

    error,

    generateDraft,

    clearResult,

  };

};